enum TiposClientes {
  Natural = 'Natural',
  Juridica = 'Juridica',
}

export default TiposClientes;
